export { capitalizerFirstLetter } from "./captalizerFirstLetter.utils";
export { alertColor } from "./alertColors.utils";
export { formatDate } from "./formatDate.utils";
export { removeSpacesFromString } from "./removeSpacesFromString.utils";
export { isValidEmailFormat } from "./emailValidator.utils";
export { generateLink } from "./generateLink.utils";
export { getFirstLetterString } from "./getFirstLetterString.utils";
export { getIconByCategory } from "./getIconByCategory.utils";
export { isDisabled } from "./isDisabled.utils";
export { identifyFileType } from "./identifyFileType.utils.js";
export * from "./getStatusStages.utils.js";
export * from "./forms.utils";
export * from "./isLightOrDark.utils";
export * from "./formsDefaultValues.utils";

export const parseHTMLToText = (encodedHtmlString) => {
    const decodedHtml = decodeURIComponent(encodedHtmlString);

    return <div dangerouslySetInnerHTML={{ __html: decodedHtml }} />;
};

export const returnEnvironment = () => {
    const customizedEnvironments = ["wizard", "favela"];
    const environment = process.env.REACT_APP_ENVIRONMENT?.toLocaleLowerCase();
    return customizedEnvironments.includes(environment) ? environment : "default";
};

export const formatInstagramHandle = (value) => {
    if (!value) return "";
    const cleanValue = value.replace(/@/g, "");
    return cleanValue ? `@${cleanValue}` : "";
};

export const stripInstagramHandle = (value) => {
    if (!value) return "";
    return value.replace(/^@/, "");
};
